
<div class="modalMain p-4 bg-white rounded shadow">
  <header class="modalTitle mb-3">
    <h2 class="h5">Define <b>Oven</b></h2>
  </header>

  <div class="modalBody">
    <form class="oven-form" [formGroup]="ovenForm" (ngSubmit)="onSubmit()">
      <!-- Name -->
      <div class="mb-3">
        <label for="name" class="form-label">Name</label>
        <input
          id="name"
          type="text"
          class="form-control"
          formControlName="name"
          required
        />
      </div>

      <!-- Serial Number -->
      

      <!-- Gateway Address -->
      <div class="mb-3">
        <label for="gateway" class="form-label">Gateway Address</label>
        <select
            id="gateway"
            class="form-select"
            formControlName="gatewayAddress"
            (change)="onGatewayChange($event)"
          >
            <option value="" disabled>Select Gateway</option>
            <option *ngFor="let gateway of gatewayAddressesList" [value]="gateway.mac_address">
              {{ gateway.mac_address }}
            </option>
          </select>
      </div>

      <!-- serial number -->
       <div class="mb-3">
        <label for="serialNumber" class="form-label">Serial Number</label>
        <input
          id="serialNumber"
          type="text"
          class="form-control"
          [(ngModel)]="newgenericSerialNo"
          formControlName="serialNumber"
          readonly
          required
        />
      </div>
      <div class="mb-3">
        <label for="site" class="form-label">Site</label>
        <select
          id="site"
          class="form-select"
          formControlName="site"
          (change)="onSiteSelected($event.target.value)"
        >
          <option value="" disabled>Select Site</option>
          <option *ngFor="let site of sitesList" [value]="site.id">
            {{ site.name }}
          </option>
        </select>
      </div>

      <!-- Application -->
      <div class="mb-3">
        <label for="application" class="form-label">Application</label>
        <select
          id="application"
          class="form-select"
          formControlName="application"
        >
          <option value="" disabled>Select Application</option>
          <option *ngFor="let application of applicationList" [value]="application.id">
            {{ application.name }}
          </option>
        </select>
      </div>

      <!-- Buttons -->
      <div class="d-flex justify-content-end gap-2 mt-4">
        <button
          class="btn btn-primary"
          type="submit"
          [disabled]="ovenForm.invalid"
        >
          Continue
        </button>
        <button class="btn btn-secondary" type="button" (click)="onClose()">
          Close
        </button>
      </div>
    </form>
  </div>
</div>

